import React from 'react';
import PropTypes from "prop-types";
import {Button} from "presentation/common/components";
import {InfoIcon} from "presentation/common/components/style-guide/icons";

export const InfoMessageContent =(props) => {
  const {
    message,
    title,
    onClose,
  } = props;

  return (
    <div style={{ width: '400px' }}>
      <div className="text-center"><InfoIcon/></div>
      <h3 className="modal-title text-center pt-1 pb-3">{title}</h3>
      <p className="text-center">{message}</p>
      <div className="flex justify-center p-2 pt-5">
        <Button className="" label="Aceptar" onClick={onClose}/>
      </div>
    </div>
  );
};

InfoMessageContent.defaultProps = {
  title: '¡Ha ocurrido un error!',
  message: 'Intente nuevamente o contáctenos.',
  onClose: PropTypes.func,
};

InfoMessageContent.propTypes = {

};

export default React.memo(InfoMessageContent);
